/**
 * Root Reducer
 *
 * Combines all feature reducers into a single root reducer.
 * Each feature's reducer is imported from its respective redux folder.
 */
import { combineReducers } from '@reduxjs/toolkit';
import { authReducer, sessionReducer } from '@/features/auth/redux';
import { chatReducer } from '@/features/chat/redux';
import { onboardingReducer } from '@/features/onboarding/redux';
import { flightsReducer } from '@/features/flights/redux';
import { hotelsReducer } from '@/features/hotels/redux';
import { hotelThankYouReducer, flightThankYouReducer } from '@/features/thankyou/redux';

export const rootReducer = combineReducers({
  auth: authReducer,
  session: sessionReducer,
  chat: chatReducer,
  onboarding: onboardingReducer,
  flights: flightsReducer,
  hotels: hotelsReducer,
  hotelThankYou: hotelThankYouReducer,
  flightThankYou: flightThankYouReducer,
});

// Export root state type
export type RootState = ReturnType<typeof rootReducer>;
